import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { UnifiedQueryV2Service } from 'src/app/shared/services';
import { CrawlRun, CrawlState } from '../models/crawler-mon.model';
import { NIGHTLY_CRAWLERS } from './crawler-diagnostics';

@Injectable({
    providedIn: 'root',
})
export class CrawlerMonService {
    private unifiedQueryV2Service = inject(UnifiedQueryV2Service);

    /**
     * Newest runs first, nightly crawlers only.
     *
     * The v2 Lambda hands `options` straight to Mongo's `find()`, so `sort` and
     * `limit` are applied server-side. A date window can't go in `query`: the
     * request is plain JSON, so an ISO string would never match an ISODate
     * field — `limit` is the only bound available here.
     */
    getRuns(limit: number): Observable<CrawlRun[]> {
        return this.unifiedQueryV2Service.query<CrawlRun>({
            db: 'lnw_crawler',
            col: 'crawl_runs',
            query: { crawler: { $in: [...NIGHTLY_CRAWLERS] } },
            options: {
                sort: { startedAt: -1 },
                limit,
            },
        });
    }

    /** Incremental watermarks — in practice just the `order` crawler's. */
    getStates(): Observable<CrawlState[]> {
        return this.unifiedQueryV2Service.query<CrawlState>({
            db: 'lnw_crawler',
            col: 'crawl_state',
            query: {},
        });
    }
}
